const INTERNAL = "internal";
const EXTERNAL = "external";

const userTypes = {
  INTERNAL,
  EXTERNAL
};

module.exports = userTypes;
